var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4058 3.71362C13.8228 3.71362 13.3502 4.18624 13.3502 4.76874C13.3502 5.35175 13.8228 5.82436 14.4058 5.82436C14.9883 5.82436 15.4609 5.35175 15.4609 4.76874C15.4609 4.18624 14.9883 3.71362 14.4058 3.71362Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71404 12.3392C8.14816 12.3392 6.87428 11.0654 6.87428 9.49999C6.87428 7.93411 8.14816 6.66025 9.71404 6.66025C11.2794 6.66025 12.5533 7.93411 12.5533 9.49999C12.5533 11.0654 11.2794 12.3392 9.71404 12.3392ZM9.71404 5.06689C7.26958 5.06689 5.28094 7.05553 5.28094 9.49999C5.28094 11.9439 7.26958 13.9326 9.71404 13.9326C12.158 13.9326 14.1466 11.9439 14.1466 9.49999C14.1466 7.05553 12.158 5.06689 9.71404 5.06689Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04706 2.19357C3.99941 2.19357 2.33381 3.85917 2.33381 5.90682V13.0932C2.33381 15.1408 3.99941 16.8064 6.04706 16.8064H13.2334C15.2811 16.8064 16.9472 15.1408 16.9472 13.0932V5.90682C16.9472 3.85917 15.2811 2.19357 13.2334 2.19357H6.04706ZM13.2334 18.5H6.04706C3.06538 18.5 0.640747 16.0744 0.640747 13.0932V5.90682C0.640747 2.92513 3.06538 0.5 6.04706 0.5H13.2334C16.2146 0.5 18.6402 2.92513 18.6402 5.90682V13.0932C18.6402 16.0744 16.2146 18.5 13.2334 18.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.35c669f43c15785808d9b60adb147f20.svg";
export { ForwardRef as ReactComponent };